/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { TourAppointment, TourAppointmentClass } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TourAppointmentsService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getTourAppointmentClasses(): Observable<TourAppointmentClass[]> {
    return this.httpClient.get<TourAppointmentClass[]>(`${environment.backendServer}/api/tour_appointments/meta`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  updateTourAppointment(appointment: TourAppointment): Observable<TourAppointment> {
    const updatedAppointment = {
      '@id': appointment['@id'],
      class: appointment.class,
      startDate: appointment.date
    };

    return this.httpClient.put<TourAppointment>(`${environment.backendServer}/api/tour_appointments/${this.extractId(appointment['@id'])}`,
      updatedAppointment, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }
}
